import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { $t } from "~/i18n.js";

import { Form, Input, Select, Switch } from "antd";

import { AddAirport } from "~/components/form/AddAirport.jsx";
import { Loader } from "~/components/loader/loader.jsx";
import { CardBase } from "~/components/timeLine/cardBase.jsx";
import { clubHasFlight } from "~/featureMatrix.jsx";

export const CardData = ({
  data,
  saveAndNext,
  prev,
  loading,
  isNew,
  templates,
}) => {
  const [form] = Form.useForm();
  const [is_vliegend, setVliegend] = useState(true);
  
  const { club } = useSelector((state) => state.persist);

  useEffect(() => {
    setVliegend(data.is_vliegend);
    form.resetFields();
  }, [data]);

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      let payload = { ...values, is_vliegend }

      // if new, then add diensten and overzicht from template
      if (isNew && templates && templates.length > 0) {
        const selectedTemplate = templates.find(
          (template) => template.name === values.type_dag
        );
        if (selectedTemplate) {
          payload = {
            ...payload,
            roosters: selectedTemplate.roosters || [],
            registration_lists: selectedTemplate.registration_lists || [],
            checklist_start_day: selectedTemplate.checklist_start_day || [],
            checklist_end_day: selectedTemplate.checklist_end_day || [],
          };
        }
      }

      saveAndNext(payload);
    } catch (info) {
      console.log("validation failed: ", info);
    }
  };

  if (loading) return <Loader />;

  return (
    <CardBase prev={prev} next={handleSave}>
      <Form
        style={{ maxWidth: 400, margin: "0 auto" }}
        form={form}
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        name="addDay"
        preserve={false}
        requiredMark={false}
        initialValues={{
          start_methode: "lier",
          type_dag: "",
          vertrek_vliegveld: club.vliegveld_icao
            ? club.vliegveld_icao
            : club.vliegveld,
          description: "",
          days_between: 10,
          briefing_tijd: "09:00",
          ...data,
          is_vliegend: clubHasFlight() ? data.is_vliegend : false,
        }}
      >
        <Form.Item
          label={$t("Rooster periode")}
          name="description"
          rules={[
            { required: true, message: $t("Voeg een beschrijving toe!") },
          ]}
        >
          <Input placeholder={$t("beschrijving")} />
        </Form.Item>

        <Form.Item
          label={$t("Soort dag")}
          extra={isNew ? $t(
            "Kies een dag template om de dagen en diensten automatisch in te vullen"
          ) : ""}
          name="type_dag"
          rules={[{ required: true, message: $t("Selecteer type") }]}
        >
          <Select placeholder={$t("Selecteer een template")} disabled={!isNew}>
            {templates?.map((template) => (
              <Select.Option key={template.name} value={template.name}>
                {template.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        {clubHasFlight() && (
          <Form.Item label={$t("Vliegend")} name="is_vliegend">
            <Switch
              onChange={(checked) => setVliegend(checked)}
              checked={is_vliegend}
              checkedChildren={$t("Ja")}
              unCheckedChildren={$t("Nee")}
            />
          </Form.Item>
        )}

        <Form.Item
          label={$t("Locatie")}
          name="vertrek_vliegveld"
          rules={[{ required: true, message: $t("Voeg een locatie toe!") }]}
        >
          <Input />
        </Form.Item>

        {clubHasFlight() && is_vliegend && (
          <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
            <AddAirport
              onSelectAirport={(airportCode) => {
                form.setFieldsValue({ vertrek_vliegveld: airportCode });
              }}
            />
          </Form.Item>
        )}

        <p className="small gray" style={{marginBottom: 18}}>
          {$t(
            'Note: Dagen worden nieuw aangemaakt op basis van de "Soort dag" en "Locatie". Als deze hetzelfde zijn met bestaande dagen worden de dagen samengevoegd.'
          )}
        </p>

        {is_vliegend && (
          <Form.Item label={$t("Start methode")} name="start_methode">
            <Select>
              {["lier", "sleep", "zelf", "tmg"].map((start, idx) => (
                <Select.Option key={idx} value={start}>
                  {$t(start)}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        )}

        <Form.Item
          label={$t("Briefing tijd")}
          name="briefing_tijd"
          rules={[{ required: true, message: $t("Voeg tijd toe!") }]}
        >
          <Input type="time" placeholder="hh:mm" />
        </Form.Item>

        <Form.Item
          label={$t("Rusttijd")}
          name="days_between"
          rules={[{ required: true, message: $t("Voeg cijfer toe!") }]}
        >
          <Input type="number" addonAfter={$t("dagen")} />
        </Form.Item>

        <p className="small gray">
          <span className="bold">{$t("Rusttijd")}: </span>{" "}
          {$t(
            "Minimaal dagen tussen diensten zorgt ervoor dat leden niet (automatisch) achterelkaar ingeroosterd worden"
          )}
          .
        </p>
      </Form>
    </CardBase>
  );
};
